import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';
import {
  segType,
  dataSourceType,
  SUM,
  AVG,
  MAX,
} from '@intelligence/pages/TopCharts/_config/enums';
import { GSD_SOURCE_KEY, GSD_METRIC_KEY_MAP } from '@intelligence/_config/sourceMetric';

export const gsdSegmentList = [
  {
    text: `dbi_metric_gsd_digital_revenue_euro`,
    value: GSD_METRIC_KEY_MAP.DIGITAL_REVENUE,
    dataSource: GSD_SOURCE_KEY,
    icon: GSD_SOURCE_KEY,
    info: `dbi_info_gsd_digitalRevenue`,
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    width: 220,
    width_cn: 200,
    sumavgArr: [SUM, AVG],
    hasByDevice: true,
    segType: segType.revenue,
    dataSourceType: dataSourceType.gsd,
    defaultSelect: false,
  },
  {
    text: `dbi_metric_gsd_physical_revenue_euro`,
    value: GSD_METRIC_KEY_MAP.PHYSICAL_REVENUE,
    dataSource: GSD_SOURCE_KEY,
    icon: GSD_SOURCE_KEY,
    info: `dbi_info_gsd_physicalRevenue`,
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    width: 230,
    width_cn: 200,
    sumavgArr: [SUM, AVG],
    hasByDevice: true,
    segType: segType.revenue,
    dataSourceType: dataSourceType.gsd,
  },
  {
    text: `dbi_metric_gsd_digital_units`,
    value: GSD_METRIC_KEY_MAP.DIGITAL_UNITS,
    dataSource: GSD_SOURCE_KEY,
    icon: GSD_SOURCE_KEY,
    info: `dbi_info_gsd_digitalUnits`,
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    width: 200,
    width_cn: 200,
    sumavgArr: [SUM, AVG],
    hasByDevice: true,
    segType: segType.revenue,
    dataSourceType: dataSourceType.gsd,
    defaultSelect: false,
  },
  {
    text: `dbi_metric_gsd_physical_units`,
    value: GSD_METRIC_KEY_MAP.PHYSICAL_UNITS,
    dataSource: GSD_SOURCE_KEY,
    icon: GSD_SOURCE_KEY,
    info: `dbi_info_gsd_physicalUnits`,
    renderType: RenderType.VALUE_AND_RATIO_NOPOINT,
    width: 200,
    width_cn: 200,
    sumavgArr: [SUM, AVG],
    hasByDevice: true,
    segType: segType.revenue,
    dataSourceType: dataSourceType.gsd,
  },
];
